import { Navigate, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import PersonalInfoPolicy from './pages/PolicyPage/PersonalInfoPolicy';
import IntegrationServiceTerm from './pages/PolicyPage/IntegrationServiceTerm';
import HelloOperationPolicy from './pages/PolicyPage/HelloOperationPolicy';
import AccountTermPolicy from './pages/PolicyPage/AccountTermPolicy';
import ROUTE_PATH from './route/constants/RoutePath';

function AppRoutes() {
    const pathList = [
        {
            path: ROUTE_PATH.HOME,
            element: <HomePage />
        },
        {
            path: ROUTE_PATH.POLICIES_PERSONAL_INFO,
            element: <PersonalInfoPolicy path={"policy/personalInfo"} />
        },
        {
            path: ROUTE_PATH.POLICIES_INTEGRATION_SERVICE,
            element: <IntegrationServiceTerm path={"policy/integrationService"} />
        },
        {
            path: ROUTE_PATH.POLICIES_HELLO_OPERATION,
            element: <HelloOperationPolicy path={"policy/helloOperation"} />
        },
        {
            path: ROUTE_PATH.POLICIES_ACCOUNT_TERM,
            element: <AccountTermPolicy path={"policy/accountTerm"} />
        },
        {
            path: '*',
            element: <Navigate to="/" replace />
        }
    ];

    return (
        <Routes>
            {pathList.map((path, idx) => {
                return <Route key={idx} path={path?.path} element={path?.element} />;
            })}
        </Routes>
    )
}

export default AppRoutes;
